<template>
  <v-app id="inspire">
    <main-menu :drawer-prop="drawer" style="padding-top:60px;" />
    <v-toolbar
      color="primary"
      dark
      fixed
      app
      style="height:60px;z-index:7"
      height="60"
      pl-1
    >
      <img src="/img/atlas-mobile.png" alt="avatar" />
      <v-spacer></v-spacer>
      <!--
      <v-badge overlap color="red" class="mr-4 mt-2" href="/inbox">
        <span slot="badge" v-if="this.unread > 0">{{ this.unread }}</span>
        <router-link to="/inbox">
          <v-icon large color="white darken-1">
            message
          </v-icon>
        </router-link>
      </v-badge>
      -->
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
    </v-toolbar>
    <v-content>
      <v-container fluid pa-0>
        <router-view :key="$route.fullPath"></router-view>
      </v-container>
    </v-content>
    <v-footer :color="!isOnline ? 'red  darken-4' : 'primary'" app>
      <span class="white--text caption px-2"
        >&copy; {{ new Date().getFullYear() }}
        {{ $vuetify.t('$vuetify.app.copyright') }}</span
      >
      <v-spacer></v-spacer>
      <span class="white--text caption px-2">{{ version }}</span>
      <v-icon dark @click="reloadApp()" v-if="isOnline">refresh</v-icon>
      <v-icon dark v-else style="width:30px">wifi_off</v-icon>
    </v-footer>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'
// @ is an alias to /src
import MainMenu from '@/components/MainMenu.vue'

export default {
  name: 'App',
  components: {
    MainMenu
  },
  props: {
    source: String
  },
  computed: {
    ...mapGetters({
      getMessageCounts: 'messaging/getMessageCounts',
      version: 'root/version'
    }),
    unread() {
      return this.getMessageCounts.unread
    }
  },
  data: () => ({
    drawer: false,
    tile: null,
    title: process.env.VUE_APP_SHORT_NAME
  }),
  methods: {
    reloadApp() {
      window.location.reload()
    }
  },
  mounted() {},
  watch: {}
}
</script>
